// "Spot the Slip" expansion — DAILY ROUTINE theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_DAILY_ROUTINE = [
  ["Hoje sou muito ocupado e não posso sair.", "Hoje estou muito ocupado e não posso sair.", "ser-estar",
    "Being busy today is a passing state → estar.", "ser-vs-estar"],
  ["De manhã sou cansado até ao café.", "De manhã estou cansado até ao café.", "ser-estar",
    "Tiredness at a given moment is a condition → estar.", "ser-vs-estar"],
  ["O meu horário de trabalho é muito regular.", "O meu horário de trabalho é muito regular.", "ser-estar",
    "Trap check: a defining feature of the schedule correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Ponho o despertador às seis todos os dias.", "Ponho o despertador às seis todos os dias.", "ser-estar",
    "Trap check: this sentence is already fully correct — no slip here.", "ser-vs-estar"],
  ["Tenho um rotina muito rígida.", "Tenho uma rotina muito rígida.", "gender",
    "Rotina is feminine → uma rotina.", "gender-agreement-of-nouns"],
  ["A fim de semana descanso em casa.", "O fim de semana descanso em casa.", "gender",
    "Fim is masculine → o fim de semana.", "gender-agreement-of-nouns"],
  ["Levo uma ritmo muito tranquilo.", "Levo um ritmo muito tranquilo.", "gender",
    "Ritmo is masculine → um ritmo.", "gender-agreement-of-nouns"],
  ["Eu gosto de as manhãs calmas.", "Eu gosto das manhãs calmas.", "gustar",
    "Gostar takes de; de + as = das.", "gostar-and-similar-verbs"],
  ["Custa-me as segundas-feiras de manhã.", "Custam-me as segundas-feiras de manhã.", "gustar",
    "Custar agrees with its subject; plural Mondays → custam.", "gostar-and-similar-verbs"],
  ["Saí cedo para chegar a tempo ao trabalho.", "Saí cedo para chegar a tempo ao trabalho.", "por-para",
    "Trap check: purpose ('in order to arrive') correctly uses para. (Already correct!)", "por-vs-para"],
  ["Estudo português de manhã por melhorar.", "Estudo português de manhã para melhorar.", "por-para",
    "Goal or purpose ('in order to improve') takes para.", "por-vs-para"],
  ["Quando era estudante, levantei-me sempre tarde.", "Quando era estudante, levantava-me sempre tarde.", "preterito-imperfecto",
    "A repeated past habit is the imperfeito → levantava-me.", "a2-preterito-vs-imperfeito"],
  ["Levanto-me às seis e tomo o pequeno-almoço rapido.", "Levanto-me às seis e tomo o pequeno-almoço rápido.", "accents",
    "Rápido is proparoxytone, so it always carries a written accent.", "stress-and-written-accents"],
  ["Quero que a minha rotina é mais saudável.", "Quero que a minha rotina seja mais saudável.", "subjunctive",
    "A wish about your routine (querer que) triggers the conjuntivo → seja.", "b1-present-subjunctive"],
  ["É necessário que dormes oito horas.", "É necessário que durmas oito horas.", "subjunctive",
    "Impersonal 'é necessário que' takes the conjuntivo → durmas.", "b1-present-subjunctive"],
];
